import React from 'react';
import { GoogleGLogo } from 'icons';
import SocialButton from './SocialButton';
import { SocialButtonProps } from './types';

export interface GoogleButtonProps
  extends Pick<
    SocialButtonProps,
    'className' | 'isDisabled' | 'onPress' | 'textAlign'
  > {}

const GoogleButton: React.FC<GoogleButtonProps> = ({
  className,
  isDisabled,
  onPress,
  textAlign,
}) => (
  <SocialButton
    fluid
    logo={<GoogleGLogo />}
    {...{ className, isDisabled, onPress, textAlign }}
  >
    Continue with Google
  </SocialButton>
);

export default GoogleButton;
